import { NavLink } from 'react-router-dom';
import { NavBarStyle, NavBarLink, NavBarMenuLink } from '../styledComponents/globalStyled'
import '../theme/core.css'
export default function NavBar() {


    return (

        <NavBarStyle>
            <NavBarLink to="/"> <h1 >Portfolio</h1></NavBarLink>
            {/* <div className="bars" /> */}

            <NavBarMenuLink>

                <NavLink to="/vrgames" className="navlink">
                    VR Games
                </NavLink>
                <NavLink to="/games" className="navlink">
                    2D & 3D Games
                </NavLink>
                <NavLink to="/art" className="navlink">
                    Art / 3D Modeling
                </NavLink>

                {/* <>
                        <NavBarHashLink to="/#Gallery" className="navlink">
                            Project Gallery
                        </NavBarHashLink>
                        <NavBarHashLink to="/#TechnicalSkills" className="navlink">
                            Technical Skills
                        </NavBarHashLink>
                        <NavBarHashLink to="/#Education" className="navlink">
                            Education
                        </NavBarHashLink>
                        <NavBarHashLink to="/#Experience" className="navlink">
                            Experience
                        </NavBarHashLink>
                    </> */}

            </NavBarMenuLink>

        </NavBarStyle>
    )
}
